export default __webpack_public_path__ + "static/media/out.15567b4f.svg";